// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* html {
  height: 100%;
} */

:root {
    background: linear-gradient(180deg, #598A84 0%, #95AA9B 80%, #A1AEA4 100%);
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* background-color: white; */

    font-size: 13pt;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.App {
    margin-top: 0px;
}

.App-header {
    width: 100%;
}

.head-box {
    display: flex;
    align-items: center;
    justify-content: right;
    z-index: 88;
}

.logo {
    margin-top: 10px;
    margin-right: 10px;
    z-index: 88;
}

.lang {
    margin-top: 5px;
    margin-right: 10px;
    z-index: 88;
}

.langbtn {
    margin-right: 5px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: 800;
}

.langbtn:hover,
.langbtn:focus {
    color: #0bdec2;
}

a:-webkit-any-link {
    text-decoration: none;
}

.defaultLn {
    color: #0bdec2;
}

.container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0 30px;
    gap: 1rem;
    margin-bottom: 10px;
}

.app-display {
    align-items: top;
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
}

.box {
    display: flex;
    color: black;
    font-weight: 300;
    border-radius: 15px;
    box-shadow: 2px 2px 2px 2px black;
    transition: width 2s, height 4s;
    min-width: 330px;
    min-height: 330px;
    flex-direction: column;
}

.box:hover {
    transform: scale(1.05);
    box-shadow: 2px 2px 2px 2px #DDD0C0;
}

.body-box {
    flex-direction: column;
    padding: 20px;
}

.app-box {
    display: flex;
    align-items: top;
    justify-content: left;
}

.app-logo {
    animation-duration: 2s;
    animation-iteration-count: infinite;
    transform-origin: bottom;
}

.bounce:hover {
    animation-name: bounce;
    animation-timing-function: ease;
}

@keyframes bounce {
    0% {
        transform: translateX(0);
    }

    50% {
        transform: translateX(100px);
    }

    100% {
        transform: translateX(0);
    }
}

.app-title {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 18pt;
    padding-bottom: 5px;
    border-bottom: 1px black solid;
    min-width: 350px;
    font-family: 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.store {
    display: flex;
    padding-left: 10px;
    padding-top: 10px;
}

.store-logo img {
    width: 80px;
    padding-left: 5px;
}

.App-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: 30px;
    color: black;
    font-size: 13pt;
    font-weight: 600;
    font-family: 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.App-footer div {
    margin-right: 5px;
}

a {
    text-decoration: none;
    color: black;
}

a:hover {
    color: #0bdec2;
}

@media screen and (max-width: 1261px) {
    .container {
        flex-direction: column;
        margin-top: 10px;
    }

    .logo {
        margin-top: 10px;
        margin-right: 10px;
    }

    .lang {
        margin-top: 0px;
        margin-right: 10px;
    }

    .app-title {
        min-width: unset;
    }
}

@media screen and (max-width: 400px) {
    .container {
        padding: 0 5px;
    }

    .logo {
        margin-top: 5px;
        margin-right: 5px;
    }

    .lang {
        margin-top: 5px;
        margin-right: 5px;
    }

    .box {
        max-width: 250px;
        max-height: 250px;
    }

    .body-box {
        overflow-wrap: break-word;
    }

    .logo {
        width: 50px;
    }

    .lang {
        margin-top: 1px;
    }

    .langbtn {
        font-size: 10pt;
        margin-top: 1px;
    }

    .defaultLn {
        margin-top: 1px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,0EAA0E;AAC9E;;AAEA;IACI,SAAS;IACT,8JAA8J;IAC9J,mCAAmC;IACnC,kCAAkC;IAClC,6BAA6B;;IAE7B,eAAe;AACnB;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,iFAAiF;AACrF;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iFAAiF;AACrF;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* html {\n  height: 100%;\n} */\n\n:root {\n    background: linear-gradient(180deg, #598A84 0%, #95AA9B 80%, #A1AEA4 100%);\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    /* background-color: white; */\n\n    font-size: 13pt;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.App {\n    margin-top: 0px;\n}\n\n.App-header {\n    width: 100%;\n}\n\n.head-box {\n    display: flex;\n    align-items: center;\n    justify-content: right;\n    z-index: 88;\n}\n\n.logo {\n    margin-top: 10px;\n    margin-right: 10px;\n    z-index: 88;\n}\n\n.lang {\n    margin-top: 5px;\n    margin-right: 10px;\n    z-index: 88;\n}\n\n.langbtn {\n    margin-right: 5px;\n    margin-left: 5px;\n    cursor: pointer;\n    font-weight: 800;\n}\n\n.langbtn:hover,\n.langbtn:focus {\n    color: #0bdec2;\n}\n\na:-webkit-any-link {\n    text-decoration: none;\n}\n\n.defaultLn {\n    color: #0bdec2;\n}\n\n.container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding: 0 30px;\n    gap: 1rem;\n    margin-bottom: 10px;\n}\n\n.app-display {\n    align-items: top;\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n}\n\n.box {\n    display: flex;\n    color: black;\n    font-weight: 300;\n    border-radius: 15px;\n    box-shadow: 2px 2px 2px 2px black;\n    transition: width 2s, height 4s;\n    min-width: 330px;\n    min-height: 330px;\n    flex-direction: column;\n}\n\n.box:hover {\n    transform: scale(1.05);\n    box-shadow: 2px 2px 2px 2px #DDD0C0;\n}\n\n.body-box {\n    flex-direction: column;\n    padding: 20px;\n}\n\n.app-box {\n    display: flex;\n    align-items: top;\n    justify-content: left;\n}\n\n.app-logo {\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    transform-origin: bottom;\n}\n\n.bounce:hover {\n    animation-name: bounce;\n    animation-timing-function: ease;\n}\n\n@keyframes bounce {\n    0% {\n        transform: translateX(0);\n    }\n\n    50% {\n        transform: translateX(100px);\n    }\n\n    100% {\n        transform: translateX(0);\n    }\n}\n\n.app-title {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 18pt;\n    padding-bottom: 5px;\n    border-bottom: 1px black solid;\n    min-width: 350px;\n    font-family: 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.store {\n    display: flex;\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.store-logo img {\n    width: 80px;\n    padding-left: 5px;\n}\n\n.App-footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    padding: 30px;\n    color: black;\n    font-size: 13pt;\n    font-weight: 600;\n    font-family: 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.App-footer div {\n    margin-right: 5px;\n}\n\na {\n    text-decoration: none;\n    color: black;\n}\n\na:hover {\n    color: #0bdec2;\n}\n\n@media screen and (max-width: 1261px) {\n    .container {\n        flex-direction: column;\n        margin-top: 10px;\n    }\n\n    .logo {\n        margin-top: 10px;\n        margin-right: 10px;\n    }\n\n    .lang {\n        margin-top: 0px;\n        margin-right: 10px;\n    }\n\n    .app-title {\n        min-width: unset;\n    }\n}\n\n@media screen and (max-width: 400px) {\n    .container {\n        padding: 0 5px;\n    }\n\n    .logo {\n        margin-top: 5px;\n        margin-right: 5px;\n    }\n\n    .lang {\n        margin-top: 5px;\n        margin-right: 5px;\n    }\n\n    .box {\n        max-width: 250px;\n        max-height: 250px;\n    }\n\n    .body-box {\n        overflow-wrap: break-word;\n    }\n\n    .logo {\n        width: 50px;\n    }\n\n    .lang {\n        margin-top: 1px;\n    }\n\n    .langbtn {\n        font-size: 10pt;\n        margin-top: 1px;\n    }\n\n    .defaultLn {\n        margin-top: 1px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
